var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.gesture_state),function(item,idx){return _c('v-row',{key:idx},[_c('v-col',[_c('span',{staticStyle:{"font-size":"x-large"}},[_vm._v(_vm._s(_vm.markers[idx]))])]),_c('v-col',[_vm._v(_vm._s(item))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }